import React from 'react';

import OperatorDropdown from 'search/filters/base/OperatorDropdown';
import {Operator, VALUELESS_OPERATORS} from 'search/SearchConstants';

import TwoInputFilterForm, {TwoInputFilterFormProps} from './TwoInputFilterForm';

interface TwoInputWithOperatorFilterFormProps extends TwoInputFilterFormProps {
  onChangeOperator: (value: Operator) => void;
  operators: Array<Operator>;
  selectedOperator: Operator;
}

export default class TwoInputWithOperatorFilterForm extends TwoInputFilterForm<TwoInputWithOperatorFilterFormProps> {
  constructor(props: TwoInputWithOperatorFilterFormProps) {
    super(props);
  }

  getNodeGrid(): Array<Array<JSX.Element>> {
    const [firstTextInput, secondTextInput] = super.getTextInputs();

    // Display operator dropdown if there are operators to choose from
    if (this.props.operators.length <= 1) {
      return [[firstTextInput], [secondTextInput]];
    }

    const operatorDropdown = (
      <OperatorDropdown
        buttonSize={this.props.buttonSize}
        onChangeOperator={this.props.onChangeOperator}
        operators={this.props.operators}
        selectedOperator={this.props.selectedOperator}
      />
    );

    // Display operator dropdown if it exists. If the operator is valueless, hide second text input.
    if (this.props.selectedOperator && VALUELESS_OPERATORS.includes(this.props.selectedOperator)) {
      return [[firstTextInput], [operatorDropdown]];
    } else {
      return [[firstTextInput], [operatorDropdown], [secondTextInput]];
    }
  }
}
